function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPause = function SvgIconPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.3V1.7m5.9 9.6V1.7",
    style: {
      fill: "none",
      stroke: "#da1b85",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
};
export { SvgIconPause as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDEzIDEzIiB2aWV3Qm94PSIwIDAgMTMgMTMiIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMyI+PHBhdGggZD0iTTMuNSAxMS4zVjEuN201LjkgOS42VjEuNyIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6I2RhMWI4NTtzdHJva2Utd2lkdGg6MztzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQiLz48L3N2Zz4=";